module.exports = __webpack_public_path__ + "assets/0280b9c1669513c941a562e5a3a88ba3.png";